export default __webpack_public_path__ + "static/media/MWC_Global-Scale-and-Skills.d9f1f4ce.jpg";